
    import {Options, Prop, Vue} from 'vue-property-decorator';
    import {JoyIconsId} from '@maltjoy/icons';

    @Options({})
    export default class TooltipInfo extends Vue {
        @Prop({type: String, default: ''})
        content!: string;

        @Prop({type: String})
        title!: string;

        @Prop({type: String})
        icon?: string;
    }
